import { Injectable } from '@angular/core';
import {ProductsService} from '../../pages/products/products.service';
import {ProductService} from '../../pages/product/product.service';
import {forkJoin, Observable} from 'rxjs';
import { Project } from 'app/pages/product/product.model';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {Bill} from './bill.model';



@Injectable({
    providedIn: 'root'
})
export class BillService {

    constructor(
        private _http: HttpClient,
        private _productService: ProductService) {

    }


    getProducts( ids: number[]): Observable<Project[]> {
        return forkJoin(ids.map(id => this._productService.getAProduct(id)));
    }

    createBilling(bill: Bill): Observable<any> {
        return this._http.post('/ypm/api/billing/create', bill);
    }

    noBilling(bill: Bill): Observable<any> {
        return this._http.post('/ypm/api/billing/noBilling', bill);
    }

    getBillDocument(billId: number): Observable<HttpResponse<Blob>> {
        return this._http.get(`/ypm/api/billing/document/${billId}`, {responseType: 'blob', observe: 'response'});
    }

}
